import type { ReactNode } from 'react'
import { AlertCircle, AlertTriangle, CheckCircle2, Circle, Clock } from 'lucide-react'
import { cx } from './cx'

export type StatusTone = 'critical' | 'serious' | 'warning' | 'good' | 'info' | 'neutral'

const TONES: Record<StatusTone, { className: string; icon: ReactNode }> = {
  critical: { className: 'bg-critical-tint text-critical', icon: <AlertCircle className="h-3 w-3" aria-hidden="true" /> },
  serious: { className: 'bg-serious-tint text-serious', icon: <AlertTriangle className="h-3 w-3" aria-hidden="true" /> },
  warning: { className: 'bg-warning-tint text-warning', icon: <AlertTriangle className="h-3 w-3" aria-hidden="true" /> },
  good: { className: 'bg-good-tint text-good', icon: <CheckCircle2 className="h-3 w-3" aria-hidden="true" /> },
  info: { className: 'bg-brand-tint text-link', icon: <Clock className="h-3 w-3" aria-hidden="true" /> },
  neutral: { className: 'bg-surface-raised text-ink-secondary', icon: <Circle className="h-3 w-3" aria-hidden="true" /> },
}

// Status is always icon + label, never color alone
export function StatusChip({ tone, children, icon }: { tone: StatusTone; children: ReactNode; icon?: ReactNode }) {
  const style = TONES[tone]
  return (
    <span className={cx('inline-flex items-center gap-[5px] whitespace-nowrap rounded-full px-[9px] py-[3px] text-xs font-semibold', style.className)}>
      {icon ?? style.icon}
      {children}
    </span>
  )
}
